module.exports = __webpack_public_path__ + "img/AT0000002612974.20bac1d2.png";